import { Routes } from '@angular/router';
import * as comps from './components';
import { SampaioHomeComponent } from '../../sampaio/main/components';
import { RealRapidoHomeComponent } from '../../real-rapido/main/components';
import { UtilHomeComponent } from '../../util/main/components/home/util-home.component';

export const GUANABARA_MAIN_ROUTES: Routes = [
    { path: '', pathMatch: 'full', component: comps.GuanabaraHomeComponent },
    { path: '', loadChildren: () => import('src/app/company/guanabara/core/guanabara-core.module').then(mod => mod.GuanabaraCoreModule) },
    { path: 'sampaio', pathMatch: 'full', component: SampaioHomeComponent},
    { path: 'sampaio', loadChildren: () => import('src/app/company/sampaio/core/sampaio-core.module').then(mod => mod.SampaioCoreModule) },
    { path: 'realexpresso', pathMatch: 'full', component: RealRapidoHomeComponent},
    { path: 'realexpresso', loadChildren: () => import('src/app/company/real-rapido/core/real-rapido-core.module').then(mod => mod.RealRapidoCoreModule)},

    { path: 'util', pathMatch: 'full', component: UtilHomeComponent},
    { path: 'util', loadChildren: () => import('src/app/company/util/core/util-core.module').then(mod => mod.UtilCoreModule)}
];